
export enum ErrorMessagesEnum {
    NO_CONNECTION = 'Во время запроса произошла ошибка. Возможно, проблема с соединением или сервер недоступен. Подождите немного и попробуйте ещё раз',
}